import firebase from 'firebase/app'
import 'firebase/auth'



const SET_SUBSCRIPTION = 'SET_SUBSCRIPTION'

const auth = {
    namespaced: true,

    state: {
        browser: {
            isChrome: false,
            info: {}
        },
        user: {},
        sources: {},
        subscription: {
            status: 'default'
        }
    },
    getters: {
        user: (state) => state.user,
    },
    mutations: {
        set(state, payload) {
            state.user = payload
        },
        setSources(state, payload) {
            state.sources = payload
        },
        [SET_SUBSCRIPTION]: (state, payload) => {
            let defaultValue = { 'status': 'not-subscribing' }
            const output = Object.assign(defaultValue, payload)
            state.subscription = output
        },
        setBrowserType(state, payload) {
            const isChrome = payload.name === 'chrome'
            state.browser.info = payload
            state.browser.isChrome = isChrome
        },
        setName(state, payload) {
            state.user.name = payload
        }
    },
    actions: {
        // emitted every time vue rendered
        init({ commit }) {
            return new Promise((resolve) => {
                firebase.auth().onAuthStateChanged((user) => {
                    let profile = {
                        auth: false,
                        uid: '',
                        email: '',
                        name: ''
                    }
                    if (user) {
                        profile = {
                            auth: true,
                            uid: user.uid,
                            email: user.email,
                            name: user.displayName
                        }
                        commit('set', profile)

                    } else {
                        commit('set', null)

                    }
                    resolve()
                })
            })
        }
    }
}

export default auth